export default __webpack_public_path__ + "static/media/cpf-piggie-bank.070f6e68.svg";